import React from 'react';
import get from 'lodash/get';
import TextInput from '../../../../core/form/TextInput';
import PropTypes from 'prop-types';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import TranslationInputContainer from '../inputs/TranslationInputContainer';

function PreEssayItemForm(props) {
  return (
    <>
      <Row>
        <Column size={12}>
          <TextInput
            required
            label="Title"
            disabled={props.submitting || props.disabled}
            value={get(props.values, 'title', '')}
            onChange={(value) => props.onChange('title', value)}
            errorText={get(props.errors, 'title', '')}
          />
        </Column>
      </Row>
      <Row>
        <Column size={12}>
          <TextInput
            required
            label="Text"
            fieldType="textarea"
            disabled={props.submitting || props.disabled}
            value={get(props.values, 'text', '')}
            onChange={(value) => props.onChange('text', value)}
            errorText={get(props.errors, 'text', '')}
          />
        </Column>
      </Row>
      <Row>
        <Column size={12}>
          <TranslationInputContainer
            onChange={props.onChange}
            submitting={props.submitting}
            values={props.values}
            errors={props.errors}
            disabled={props.submitting || props.disabled}
          />
        </Column>
      </Row>
    </>
  );
}

PreEssayItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default PreEssayItemForm;
